/**
 * Analytics utility with OneTrust consent checking
 */

/**
 * Check if analytics cookies are consented (C0002 - Performance Cookies)
 * @returns {boolean}
 */
export function hasAnalyticsConsent() {
  return !!(window.OnetrustActiveGroups && window.OnetrustActiveGroups.includes('C0002'));
}

/**
 * Check if functional cookies are consented (C0003 - Functional Cookies)
 * @returns {boolean}
 */
export function hasFunctionalConsent() {
  return !!(window.OnetrustActiveGroups && window.OnetrustActiveGroups.includes('C0003'));
}

/**
 * Safe gtag event tracking with OneTrust consent check
 * @param {Object} context - Vue component context (for accessing $gtag)
 * @param {string} eventName - GA4 event name
 * @param {Object} parameters - Event parameters
 */
export function trackEvent(context, eventName, parameters = {}) {
  if (!hasAnalyticsConsent()) {
    console.log(`Analytics event blocked (no consent): ${eventName}`, parameters);
    return;
  }
  
  if (!context.$gtag) {
    console.warn('$gtag not available in component context');
    return;
  }
  
  context.$gtag.event(eventName, parameters);
}

/**
 * Safe gtag opt-in with OneTrust consent check
 * @param {Object} context - Vue component context (for accessing $gtag)
 */
export function optInAnalytics(context) {
  if (!hasAnalyticsConsent()) {
    console.log('Analytics opt-in blocked (no consent)');
    return;
  }
  
  if (!context.$gtag) {
    console.warn('$gtag not available in component context');
    return;
  }
  
  context.$gtag.optIn();
} 